import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Form, useFormikContext } from 'formik';
import {
  DimensionSelection,
  InterestDimensionSelection,
  General,
  EmailTemplates,
  DistortionSelection,
} from './FormSection';
import { getCommunicationTemplateForAsmt } from '../../../../../utils/TemplateUtil';
import { getEntityListWithAccount } from '../../../../../utils/AppUtil';
import AssessmentTempLanguages from './AssessmentTempLanaguages';
import useSubscriptionExpiredRestrictions from '../../../../../hooks/useSubscriptionExpiredRestrictions';

const messages = defineMessages({
  save: { id: 'actions.save', defaultMessage: 'Save' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  behavior: {
    id: 'jobMatching.behaviorSection',
    defaultMessage: 'Behavior Section',
  },
  cognitive: {
    id: 'jobMatching.cognitiveSection',
    defaultMessage: 'Cognitive Section',
  },
  interests: {
    id: 'jobMatching.interestSection',
    defaultMessage: 'Interests Section',
  },
  distortion: {
    id: 'jobMatching.distortion',
    defaultMessage: 'Distortion',
  },
});

const AssessmentTempComponent = ({ data, handleCancle }) => {
  const { isSubmitting, setFieldValue, values } = useFormikContext();
  const { formatMessage } = useIntl();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const { account } = data;
  const { behaviorSection, cognitiveSection, interestsSection } = account.assessmentSections;
  const accountTemplates = getEntityListWithAccount(account, 'communicationTemplates');
  // this is for communication templates
  const commuTemplates = getCommunicationTemplateForAsmt(accountTemplates);
  const areAnyDimensionsSelected =
    (values.behavior && values.behavior.length > 0) ||
    (values.distortion && values.distortion.length > 0) ||
    (values.cognitive && values.cognitive.length > 0) ||
    (values.interest && values.interest.length > 0);

  const behaviorLabel = formatMessage(messages.behavior);
  const cognitiveLabel = formatMessage(messages.cognitive);
  const interestLabel = formatMessage(messages.interests);
  const distortionLabel = formatMessage(messages.distortion);
  return (
    <Form>
      <div className="p-grid">
        <div className="p-col-12">
          <Panel header={<FormattedMessage id="assessment.temp.new" defaultMessage="New Assessment Template" />}>
            <div className="p-grid">
              <div className="p-sm-12 p-md-6">
                <General />
              </div>
              <div className="p-col-12">
                <EmailTemplates templates={commuTemplates} />
              </div>
              <div className={areAnyDimensionsSelected ? 'p-col-8' : 'p-col-12'}>
                <Panel header={<FormattedMessage id="temp.dimensions" defaultMessage="Dimensions" />}>
                  <DimensionSelection
                    dimensions={behaviorSection.dimensions}
                    text={behaviorLabel}
                    fieldName="behavior"
                    setFieldValue={setFieldValue}
                  />
                  <DimensionSelection
                    dimensions={cognitiveSection.dimensions}
                    text={cognitiveLabel}
                    fieldName="cognitive"
                    setFieldValue={setFieldValue}
                  />
                  <DistortionSelection
                    dimensions={behaviorSection.distortion}
                    fieldName="distortion"
                    text={distortionLabel}
                    setFieldValue={setFieldValue}
                  />
                  <InterestDimensionSelection
                    dimensions={interestsSection.dimensions}
                    text={interestLabel}
                    fieldName="interest"
                    setFieldValue={setFieldValue}
                  />
                </Panel>
              </div>
              {areAnyDimensionsSelected && (
                <div className="p-col-4">
                  <AssessmentTempLanguages
                    formValues={values}
                    behaviorSection={behaviorSection}
                    cognitiveSection={cognitiveSection}
                    interestsSection={interestsSection}
                  />
                </div>
              )}
              <div className="p-col-12">
                <Button
                  type="submit"
                  disabled={isSubmitting || subscriptionIsExpired}
                  icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
                  label={formatMessage(messages.save)}
                />
                <Button
                  type="button"
                  className="p-button-secondary"
                  onClick={handleCancle}
                  label={formatMessage(messages.cancel)}
                />
              </div>
            </div>
          </Panel>
        </div>
      </div>
    </Form>
  );
};
AssessmentTempComponent.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  handleCancle: PropTypes.func.isRequired,
};

export default AssessmentTempComponent;
